import stringify from 'json-stringify-safe';
export class AcceptPaymentsFeatureMissingError extends Error {
  constructor() {
    super('Accept payments feature missing');
    Object.setPrototypeOf(this, AcceptPaymentsFeatureMissingError.prototype);
  }
}
export class PurchaseLimitExceededError extends Error {
  constructor() {
    super('Purchase limit exceeded.');
    Object.setPrototypeOf(this, PurchaseLimitExceededError.prototype);
  }
}
export class CheckoutDataDecodeError extends Error {
  constructor(details) {
    super(details);
    Object.setPrototypeOf(this, CheckoutDataDecodeError.prototype);
  }
}
export class EmptyCheckoutDataError extends Error {
  constructor() {
    super('Missing checkout data.');
    Object.setPrototypeOf(this, EmptyCheckoutDataError.prototype);
  }
}
export class LowercaseCheckoutDataError extends Error {
  constructor(data) {
    super(`Crawler lowercased encoded data: ${data}`);
    Object.setPrototypeOf(this, LowercaseCheckoutDataError.prototype);
  }
}
export class StatusDataDecodeError extends Error {
  constructor(details) {
    super(details);
    Object.setPrototypeOf(this, StatusDataDecodeError.prototype);
  }
}
export class IntegrationDataDecodeError extends Error {
  constructor(details) {
    super(details);
    Object.setPrototypeOf(this, IntegrationDataDecodeError.prototype);
  }
}
export class AppSectionParamsDecodeError extends Error {
  constructor(details) {
    super(details);
    Object.setPrototypeOf(this, AppSectionParamsDecodeError.prototype);
  }
}
export class MissingRequiredParameterError extends Error {
  constructor() {
    for (var _len = arguments.length, parameterNames = new Array(_len), _key = 0; _key < _len; _key++) {
      parameterNames[_key] = arguments[_key];
    }
    super(`Missing parameters: ${parameterNames.join(', ')}.`);
    Object.setPrototypeOf(this, MissingRequiredParameterError.prototype);
  }
}
export const toError = e => e instanceof Error ? e : new Error(typeof e === 'string' ? e : stringify(e));
//# sourceMappingURL=errors.js.map